import { Routes, Route, Navigate, Link } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { CompanyProvider } from "./contexts/CompanyContext";
import Upload from "./pages/Upload";
import SignedList from "./pages/SignedList";
import Sign from "./pages/Sign";
import Login from "./pages/Login";
import Unauthorized from "./pages/Unauthorized";
import SolicitudParteTrabajo from "./pages/SolicitudParteTrabajo";
import SolicitudesHub from "./pages/SolicitudesHub";
import HistorialSolicitudes from "./pages/HistorialSolicitudes";
import DetalleSolicitud from "./pages/DetalleSolicitud";
import EditarSolicitud from "./pages/EditarSolicitud";
import SolicitudAlbaran from "./pages/SolicitudAlbaran";
import HistorialAlbaranes from "./pages/HistorialAlbaranes";
import DetalleAlbaran from "./pages/DetalleAlbaran";
import AlbaranesHub from "./pages/AlbaranesHub";
import FixSolicitudes from "./pages/FixSolicitudes";
import FormularioPRL from "./pages/FormularioPRL";
import UserProfile from "./pages/UserProfile";
import GenerarDECA from "./pages/GenerarDECA";
import ListaDECA from "./pages/ListaDECA";
import VerificarDECA from "./pages/VerificarDECA";
import GestionUsuarios from "./pages/GestionUsuarios";
import ProtectedRoute from "./components/ProtectedRoute";
import SessionGuard from "./components/SessionGuard";
import SuperAdminLayout from "./components/SuperAdminLayout";
import CompanyAdminLayout from "./components/CompanyAdminLayout";
import UserLayout from "./components/UserLayout";
import { 
  SuperAdminDashboard, 
  SuperAdminCompanies, 
  SuperAdminUsers,
  CreateUser,
  SuperAdminPermissions,
  SuperAdminStats 
} from "./pages/SuperAdmin";
import {
  CompanyAdminDashboard,
  CompanyAdminUsersManagement,
  CompanyAdminDocuments,
  CompanyAdminSettings
} from "./pages/CompanyAdmin";

function AppContent() {
  return (
    <Routes>
      {/* Rutas públicas */}
      <Route path="/login" element={<Login />} />
      <Route path="/sign/:id" element={<Sign />} />
      <Route path="/prl/:id" element={<FormularioPRL />} />
      <Route path="/verificar-deca/:id" element={<VerificarDECA />} />
      <Route path="/unauthorized" element={<Unauthorized />} />

      {/* Rutas de usuario con sidebar */}
      <Route element={<ProtectedRoute><UserLayout /></ProtectedRoute>}>
        <Route path="/" element={<Navigate to="/upload" replace />} />
        <Route path="/upload" element={<Upload />} />
        <Route path="/docs" element={<SignedList />} />
        <Route path="/profile" element={<UserProfile />} />
        <Route path="/solicitudes" element={<SolicitudesHub />} />
        <Route path="/solicitar-parte" element={<SolicitudParteTrabajo />} />
        <Route path="/generar-deca" element={<GenerarDECA />} />
        <Route path="/lista-deca" element={<ListaDECA />} />
        <Route path="/gestion-usuarios" element={<GestionUsuarios />} />
        <Route path="/historial-solicitudes" element={<HistorialSolicitudes />} />
        <Route path="/solicitud/:id" element={<DetalleSolicitud />} />
        <Route path="/solicitud/:id/editar" element={<EditarSolicitud />} />
        <Route path="/albaranes" element={<AlbaranesHub />} />
        <Route path="/solicitar-albaran" element={<SolicitudAlbaran />} />
        <Route path="/historial-albaranes" element={<HistorialAlbaranes />} />
        <Route path="/albaran/:id" element={<DetalleAlbaran />} />
        <Route path="/fix-solicitudes" element={<FixSolicitudes />} />
      </Route>

      {/* Super Admin */}
      <Route
        path="/super-admin"
        element={<ProtectedRoute requiredRole="super_admin"><SuperAdminLayout /></ProtectedRoute>}
      >
        <Route index element={<SuperAdminDashboard />} />
        <Route path="companies" element={<SuperAdminCompanies />} />
        <Route path="users" element={<SuperAdminUsers />} />
        <Route path="users/new" element={<CreateUser />} />
        <Route path="permissions" element={<SuperAdminPermissions />} />
        <Route path="stats" element={<SuperAdminStats />} />
      </Route>

      {/* Company Admin */}
      <Route
        path="/admin"
        element={<ProtectedRoute requiredRole="company_admin"><CompanyAdminLayout /></ProtectedRoute>}
      >
        <Route index element={<CompanyAdminDashboard />} />
        <Route path="users" element={<CompanyAdminUsersManagement />} />
        <Route path="documents" element={<CompanyAdminDocuments />} />
        <Route path="settings" element={<CompanyAdminSettings />} />
      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <CompanyProvider>
        <SessionGuard>
          <AppContent />
        </SessionGuard>
      </CompanyProvider>
    </AuthProvider>
  );
}

function NotFound() {
  return (
    <div className="container">
      <div className="card" style={{ textAlign: "center", padding: "48px 24px" }}>
        <h1 style={{ fontSize: "48px", margin: "0 0 16px" }}>404</h1>
        <p className="meta">Página no encontrada</p>
        <Link to="/upload" className="btn" style={{ marginTop: 24, display: "inline-block" }}>
          Volver al inicio
        </Link>
      </div>
    </div>
  );
}
